package com.example.mystybag.core.expected

import kotlinx.browser.document
import org.w3c.dom.HTMLStyleElement
import org.w3c.dom.url.URL
import kotlin.js.js

private const val GOOGLE_SANS_DOM_STYLE_ID = "mystybag-google-sans-fontfaces-dom"

private fun documentBaseForAssets(): String =
    (js("(typeof document !== 'undefined' && document.baseURI) ? document.baseURI : window.location.href") as String)

private fun fontAssetHref(fileName: String): String =
    URL("fonts/$fileName", documentBaseForAssets()).href

/**
 * Registers `@font-face` for **Google Sans** so plain DOM nodes can use
 * `font-family: 'Google Sans', system-ui, sans-serif` — same files as moko
 * `SRC.fonts` / Compose [com.example.mystybag.core.ui.theme.LocalTheme.googleSans].
 * Webpack emits them under `fonts/` in the web bundle.
 */
fun ensureGoogleSansFontFacesForDom() {
    if (document.getElementById(GOOGLE_SANS_DOM_STYLE_ID) != null) return
    val faces = listOf(
        400 to "google_sans_regular.ttf",
        500 to "google_sans_medium.ttf",
        600 to "google_sans_semibold.ttf",
        700 to "google_sans_bold.ttf",
    ).joinToString("\n") { (weight, file) ->
        val href = fontAssetHref(file).replace("'", "%27")
        """
@font-face {
  font-family: 'Google Sans';
  src: url('$href') format('truetype');
  font-weight: $weight;
  font-style: normal;
  font-display: swap;
}
        """.trimIndent()
    }
    val style = document.createElement("style") as HTMLStyleElement
    style.id = GOOGLE_SANS_DOM_STYLE_ID
    style.textContent = faces
    document.head?.appendChild(style)
}

/** Font stack for raw DOM when Compose theme is not applied. */
fun googleSansFontFamilyCss(): String = "'Google Sans', system-ui, sans-serif"
